<template>
<b-modal ref="editItem" title="Rediger">
  <form @submit.prevent="write">
    <div class="form-group">
      <label>Kategori:</label>
      <b-form-input v-model="item.category" type="text" class="form-control" />
      <label>Gruppe:</label>
      <b-form-input v-model="item.group" type="text" class="form-control" />
      <label>Type:</label>
      <b-form-input v-model="item.type" type="text" class="form-control" />
      <label>Beskrivelse:</label>
      <textarea v-model="item.description" class="form-control" />
      <price v-model="item.price" />
      </div>
    </form>
    <template slot="modal-footer">
      <b-button
        variant="success"
        size="sm"
        @click="edit()">Gem
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  db
} from '../../config/firebase';
import Price from '../input/Price'
export default {
  name: 'EditItem',
  components: {
    'price': Price
  },
  data() {
    return {
      id: '',
      item: {
        category: '',
        group: '',
        type: '',
        description: '',
        price: ''
      }
    }
  },
  computed: {
    state() {
      return this.item.price.length >= 4 ? true : false
    },
    invalidFeedback() {
      if (this.item.price.length > 0) {
        return ''
      } else if (this.item.price.length == 0) {
        return 'Angiv mindst et tal'
      } else {
        return 'Angiv et tal'
      }
    },
    validFeedback() {
      return this.state === true ? '' : ''
    }
  },
  firebase: {
    products: db.ref('products')
  },
  methods: {
    edit() {
      this.$firebaseRefs.products.child(this.id).set(this.item);
      this.$refs.editItem.hide()
    },
    show(item) {
      this.id = item['.key']
      this.item.category = item.category
      this.item.group = item.group
      this.item.type = item.type
      this.item.description = item.description
      this.item.price = item.price
      this.$refs.editItem.show()
    }
  }
}
</script>

<style scoped>
</style>
